import { useEvent, useUnit } from 'effector-react';
import { Button, Popover, Tooltip } from 'antd';
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  TableOutlined,
} from '@ant-design/icons';
import Select from 'antd/es/select';
import { setDashboardModalOpenEv } from '../../../models/overviewModel/index.js';
import style from '../Overview.module.css';
import { changeRegionsOkedsModalEv } from '../../../models/investProjectsModel/index.js';
import {
  ChartGrowIcon,
  ChartNewIcon,
  ChartTableIcon,
} from '../../../utils/customIcons.jsx';

export default function OverviewCard(props) {
  const {
    title,
    cards,
    cardClick,
    field,
    activeSubCategory,
    setIsOpen,
    showInfo = true,
    selects,
  } = props;

  const openDashboardModal = useEvent(setDashboardModalOpenEv);
  const changeRegionsOkedsModal = useUnit(changeRegionsOkedsModalEv);

  const openModal = (type) => {
    setIsOpen({ visible: true, modalType: type });
  };

  return (
    <div
      className={style.overview_card}
      onClick={cardClick}
      data-category={field}
      data-subcategory={cards[0].subCategory}
      data-type="card"
    >
      {!!title && !!selects && selects.length > 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {title && <span className={style.overview_card_title}>{title}</span>}
          {selects && selects.length > 0
            ? selects.map((select, index) => {
                return (
                  <Select
                    key={`${title}-select-${index}`}
                    options={select.options}
                    defaultValue={select.value}
                    value={select.value}
                    onChange={select.onChange}
                    style={{ width: 140 }}
                  />
                );
              })
            : ''}
        </div>
      ) : title ? (
        <span className={style.overview_card_title}>{title}</span>
      ) : null}
      <div className={style.cards_wrapper}>
        {cards.map((item) => {
          return (
            <div
              className={[
                style.overview_subcard,
                cards?.length === 1 ? style.card_full_width : '',
                activeSubCategory.length > 0 &&
                activeSubCategory === item.subCategory
                  ? style.overview_subcard_active
                  : '',
              ].join(' ')}
              data-category={field}
              data-subcategory={item.subCategory}
              data-type="subcard"
            >
              <div
                className={`${
                  item.breakWord
                    ? style.title_break
                    : style.overview_subcard_title
                } ${showInfo && 'flex-8'}`}
              >
                {item.title}
                {/*{showInfo && (*/}
                {/*  <div>*/}
                {/*    <Popover*/}
                {/*      title={*/}
                {/*        <div*/}
                {/*          style={{*/}
                {/*            display: 'flex',*/}
                {/*            flexDirection: 'column',*/}
                {/*            gap: 4,*/}
                {/*          }}*/}
                {/*        >*/}
                {/*          <span>{`Источник данных: ${*/}
                {/*            infoSourceDictionary[item.subCategory]*/}
                {/*          }`}</span>*/}
                {/*          <span>{`Актуализация: ${*/}
                {/*            actualityDictionary[item.subCategory]*/}
                {/*          }`}</span>*/}
                {/*        </div>*/}
                {/*      }*/}
                {/*    >*/}
                {/*      <InfoCircleOutlined style={{ height: 16 }} />*/}
                {/*    </Popover>*/}
                {/*  </div>*/}
                {/*)}*/}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div className={style.overview_value}>{item.value}</div>
                <div className={style.overview_measure}>{item.measure}</div>
              </div>

              <div className={style.overview_subcard_footer}>
                <div className={style.overview_subcard_date}>
                  {item.granularity ? (
                    <>
                      <span>
                        {item.date?.split(' ')?.slice(0, 2)?.join(' ') ?? ''}
                      </span>
                      <span>{item.date?.split(' ')?.at(-1) ?? ''}</span>
                    </>
                  ) : (
                    item.date.split(' ').map((i) => <span>{i}</span>)
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: 4,
                    flexDirection: 'row-reverse',
                  }}
                >
                  {item.projectsButton === true ? (
                    <Tooltip title="Просмотр проектов" placement="bottom">
                      <Button
                        className={style.modal_button}
                        icon={
                          item.subCategory === 'problemProjects'
                            ? ChartGrowIcon
                            : ChartNewIcon
                        }
                        onClick={() =>
                          item.subCategory !== 'projectCount'
                            ? openModal(item.subCategory)
                            : changeRegionsOkedsModal(true)
                        }
                        // onClick={() => openModal(item.subCategory) }
                      />
                    </Tooltip>
                  ) : (
                    ''
                  )}
                  {item.infoModal && !item.noButton ? (
                    <Tooltip title="Просмотр таблицы" placement="bottom">
                      <Button
                        className={style.modal_button}
                        icon={<TableOutlined />}
                        onClick={() => item.infoModal(item.subCategory)}
                      />
                    </Tooltip>
                  ) : (
                    ''
                  )}
                  {item.dashboardButton === true ? (
                    <Tooltip
                      title="Количество созданных проектов"
                      placement="top"
                    >
                      <Button
                        className={style.dashboard_button}
                        icon={ChartTableIcon}
                        onClick={() => openDashboardModal(true)}
                      />
                    </Tooltip>
                  ) : (
                    ''
                  )}
                  {item.popovers && item.popovers.length > 0 ? (
                    <>
                      {item.popovers.map((popover, index) => {
                        const popoverContent = (
                          <div>
                            <div>{popover.title}</div>
                            <div>
                              {popover.items.map((elem, subindex) => {
                                return (
                                  <div
                                    key={`${elem.subCategory}-popover-${index}-${subindex}`}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <div>{elem.label}</div>
                                    <div>{elem.value}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                        return (
                          <Popover
                            content={popoverContent}
                            key={`${item.subCategory}-popover-${index}`}
                          >
                            <Button
                              icon={popover.icon}
                              style={{ borderColor: 'var(--primary)' }}
                            />
                          </Popover>
                        );
                      })}
                    </>
                  ) : (
                    ''
                  )}
                </div>
                {field !== 'projectsRealisation' && field !== 'cluster' ? (
                  <div
                    className={style.overview_subcard_percent}
                    style={{
                      color:
                        item.type === 'neutral'
                          ? 'var(--warning)'
                          : item.type === 'positive'
                          ? 'var(--success)'
                          : 'var(--danger)',
                    }}
                  >
                    {item.percent ?? ''}%
                    {item.subCategory === 'problemProjSum' ? (
                      <ArrowUpOutlined />
                    ) : item.type !== 'neutral' ? (
                      item.type === 'positive' ? (
                        <ArrowUpOutlined />
                      ) : (
                        <ArrowDownOutlined />
                      )
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
